import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { RoomDetailsService } from 'app/shared/services/room-details.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';


@Component({
  selector: 'ngx-room-details',
  templateUrl: './room-details.component.html',
  styleUrls: ['./room-details.component.scss']
})
export class RoomDetailsComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  isDark: boolean = false;
  itemForm: FormGroup;
  isItemCodeReadOnly : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;


  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


   roomType2 =[
    {value: 'STD DBL FAN'},
    {value: 'STD DBL'},
    {value: 'STD TRPL'},
    {value: 'STD FML '}, 
    {value: 'SUPR DBL '},
    {value: 'SUPR TRPL'},
    {value: 'SUPR FML'},  
    {value: 'SUPR KNG'}, 
    {value: 'DLX DBL'}, 
    {value: 'DLX OLU'}, 
    {value: 'DLX NELUM'}, 
    {value: 'DLX ARALIYA'}, 
    {value: 'DLX KARADA'}, 
  
  ];

   roomType =[
    {value: 'Deluxe'},
    {value: 'Superior'},
    {value: 'Luxury'},
    {value: 'Budget'}, 
  ];

  bedType =[
    {value: '1 double bed'},
    {value: '1 single bed  and  1 double bed'},
    {value: '2 single beds  and  1 double bed'},
    {value: '2 double bed'},

  ];

  validationMessages = {
    'roomId' : { 'required': 'This field is required' },
    'roomType' : { 'required': 'This field is required' },
    'roomNo' : { 'required': 'This field is required' },

  };

  formErrors = {
    'roomId': "",
    'roomType' : "",
    'roomNo'  : "",
  };



  constructor(private fb: FormBuilder,
               private roomDetailsService :RoomDetailsService,
              private authService: AuthService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private themeService: NbThemeService,
              private router : Router, 
             ) { 
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
             }

  ngOnInit() {
    this.initFormFields();
    this.getDataTableRowData();
    this.getControlPermissions();
 
   this.itemForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.itemForm);
  });

  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
 

  } // end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RD'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  initFormFields() : void{
    this.itemForm = this.fb.group({
      id : [null],
      roomId: ['',Validators.required],
      roomType: ['',Validators.required],
      roomNo: ['',Validators.required],
      roomExtNo: [''],
      breakfast: [''],
      bedType: [''],
      otherFacilities: [''],
      availability: [''],


    });
  }

  newButtonClick(): void {
    this.itemForm.reset();
    this.enableForm();
    this.isItemCodeReadOnly = false;
    this.getMaxId();
   }

   getMaxId(){
    var id = 0;
    var sId : String;
  
    this.roomDetailsService.getMaxId()
    .subscribe(
      (res) => {
                  id = Number(res[0].MaxId) + 1;
                  sId = id.toString().padStart(3,'0');
                  this.itemForm.patchValue({
                    roomId : "R" + sId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }


  saveButtonClick(): void {
    
    this.logValidationErrors(this.itemForm,true);
    const formData =this.mapFormValuesToModel();
          if(this.isFilledFromFields()){
            
              if(!this.itemForm.value.id){
                this.showProcessingIndicator = true;
                this.roomDetailsService.addRoomDetails(formData)
                .subscribe(
                  (res) => {
                              console.log(res);
                             if(res.success === 0){
                                this.toastr.error('This room id already exist.', 'warning');
                                this.showProcessingIndicator = false;
                             }else if(res.success === 1){
                                this.toastr.success('Room details added successfully','Success');                          
                                this.showProcessingIndicator = false; 
                                this.newButtonClick();
                              }
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                                                         
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                    

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.roomDetailsService.updateRoomDetails(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Updated successfully','Success');     
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }



   enableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].enable();
      
    });

  }


  disableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].disable();   
    });

  }
  
  logValidationErrors(group: FormGroup = this.itemForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.itemForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
  }

  


  mapFormValuesToModel(){  
      let formData ={
        ...this.itemForm.value,
        createdBy : this.authService.getUserLoggedIn(),
      }
  
      return formData;
  }


activeStatus = false;
viewItem(data:any){
  this.itemForm.patchValue({  
    id      :data.Id,
    roomId:data.RoomId,
    roomType:data.RoomType,
    roomNo:data.RoomNo,
    roomExtNo:data.RoomExtNo,
    breakfast:data.Breakfast,
    bedType:data.BedType,
    otherFacilities:data.OtherFacilities,
    availability:data. Availability,  
    
  })

 

}

getDataTableRowData(){
  var data = this.roomDetailsService.dataRow;
  if(data){
    this.viewItem(data);
  }
  else{
    this.newButtonClick();
  }

}


}
